import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import { Img } from "@storybook/components";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroupsPropsExternalTrainings } from "./ButtonGroupsExternalTrainings.types";
// import deleteIcon from "../../assets/Elimina.svg";
import { ButtonDigited } from "../../components/Button/Button.variants";




export const ButtonGroupsExternalTrainings: React.FC<ButtonGroupsPropsExternalTrainings> = ({ onClickDelete, onClickCancel, onClickConfirm, isPending, isCourseSelected }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isCustomSize = useMediaQuery("(max-width: 1350px)");

  return (
    <Box
      sx={ {
        display: "flex",
        mt: "10px",
        flex: "1 1",
        flexDirection: "center",
        justifyContent: "space-between",
        gap: isMobile ? 1 : 0,
        pt: 2
      } }
    >
      <Box
        sx={ {
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-end",
          width: isMobile ? "100%" : "auto",
          gap: 1 ,
          flexDirection: isCustomSize ? "column" : "row"
        } }
      >
        { !isCourseSelected && 
          <ButtonDigited
            typology="tertiary"
            disabled={ !isPending } 
            onClick={ onClickDelete } 
            sx={ {
              display: "flex",
              justifyContent: isMobile ? "center" : "flex-end",
              width: isMobile ? "100%" : "auto",
              fontWeight: "bold",
              paddingLeft: 2,
              paddingBottom: 2
            } }
          >
            { t("delete") }
          </ButtonDigited> }
        
      </Box>
      <Box
        sx={ {
          display: "flex",
          justifyContent: "end",
          width: isMobile ? "100%" : "auto",
          gap: 1 
        } }
      >
        { !isCourseSelected && 
          <ButtonDigited
            typology="secondary"
            id="cancel"
            sx={ {
              mb: "10px",
              opacity: 1
            } }
            onClick={ onClickCancel }
            disabled={ !isCourseSelected && !isPending }
          >
            { t("annul") }
          </ButtonDigited> 
        }
        { !isCourseSelected && 
          <ButtonDigited
            typology="primary"
            id={ "confirm" }
            sx={ {
              mb: "10px"
            } }
            onClick={ onClickConfirm }
            disabled={ isCourseSelected }
          >
            { t("confirm") }
          </ButtonDigited> }
      </Box>
    </Box>
  );
};
